<template>
    <button @click.prevent="showEditModal = true" class="btn btn-warning">
        <i class="fa fa-lg fa-edit"></i>
        <document-edit-modal
            v-on="$listeners"
            :show-modal.sync="showEditModal"
            :file="file"
        />
    </button>
</template>

<script>
    import DocumentEditModal from "./document-edit-modal"

    export default {
        name: "documentEditButton",
        components: { DocumentEditModal },

        data() {
            return {
                showEditModal: false
            }
        },
        props: {
            file: {
                type: Object,
                required: true,
            }
        },
    }
</script>
